export const errorBackgroundColor = '#f2dede';
export const errorTextLightColor = '#d49191';
export const errorTextColor = '#f00';
export const errorBorderColor = '#f00';
export const errorAxisColor = '#f00';

export const warningBackgroundColor = '#fff2e6';
export const warningTextLightColor = '#ffd4ac';
export const warningTextColor = '#f93';
export const warningBorderColor = '#f93';
export const warningAxisColor = '#f93';

export const infoBackgroundColor = '#c0e7f7';
export const infoTextLightColor = '#2dafe4';
export const infoTextColor = '#39c';
export const infoBorderColor = '#39c';
export const infoAxisColor = '#ccc';

export const successTextColor = '#3c6';
export const successBorderColor = '#3c6';
export const successShewhartColor = '#099';

export const missingTextColor = '#ccc';
export const cancelTextColor = '#ccc';
export const startedTextColor = '#f9c';
export const createdTextColor = '#fafafa';
export const greyTextColor = '#ccc';

export const whiteTextColor = '#fff';
export const blackTextColor = '#000';
export const logInfoTextColor = '#990';
export const logDebugTextColor = '#39c';

export const whiteBackgroundColor = '#fff';
export const greyBackgroundColor = '#ccc';
export const noBackgroundColor = '';

export const ticketNewColor = '#c36';
export const ticketAssignedColor = '#f93';
export const ticketCompletedColor = '#39c';
export const ticketRejectedColor = '#939';
export const ticketClosedColor = '#ccc';